import React from 'react'
import BaseIcon from 'react-icon-base'

const FR = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <defs>
      <rect id="fr_svg__a" width={21} height={15} rx={2} />
      <rect id="fr_svg__c" width={20} height={14} x={0.5} y={0.5} rx={1} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="fr_svg__b" fill="#fff">
        <use xlinkHref="#fr_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#fr_svg__a" />
      <path fill="#435DB0" d="M0 0h7v15H0z" mask="url(#fr_svg__b)" />
      <path fill="#ED4C49" d="M14 0h7v15h-7z" mask="url(#fr_svg__b)" />
      <use stroke="#2F343A" strokeOpacity={0.157} xlinkHref="#fr_svg__c" />
    </g>
  </BaseIcon>
)

export default FR
